import {ChangeDetectorRef, Component, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FUIKeysControlComponent),
    multi: true
};

@Component({
    providers: [CUSTOM_VALUE_ACCESSOR],
    selector: "fui-keys-control",
    styleUrls: ["./keys-control.component.scss"],
    templateUrl: "./keys-control.component.html",
    standalone: false
})
export class FUIKeysControlComponent extends FUIAbstractControl {
    public keys: Array<string>;

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);

        this.keys = ["7", "8", "9", "4", "5", "6", "1", "2", "3", "0"];
    }

    /**
     * Add a value to the array
     * @param {string} key
     */
    add(key: string): void {
        this.value.push(key);
    }

    /**
     * Remove items from the array
     */
    backspace(): void {
        this.value.pop();
    }
}
